import useClickOutSide from 'hooks/useClickOutSide'
import { useEffect, useRef, useState } from 'preact/hooks'
import clsx from 'clsx'

function CustomDropdown({
  label,
  items,
  required,
  value,
  error = '',
  wrapClass = '',
  classLabel = '',
  classInput = '',
  contentClass = '',
  placeholder = 'Select Option',
  onChange,
  disabled = false,
  isCustom = false
}) {
  const [selectedValue, setSelectedValue] = useState(value || placeholder)
  const [isActive, setIsActive] = useState(false)
  const [hideLabel, setHideLabel] = useState(true)
  const refSelector = useRef(null)

  const onChangeValue = (e) => {
    const currentValue = e.target.dataset.value === '' ? placeholder : e.target.dataset.value

    if (isCustom) {
      const selectedItem = items.find(item => item.value === currentValue)

      setSelectedValue(selectedItem)
      setHideLabel(true)
    } else {
      setSelectedValue(currentValue)
      setHideLabel(currentValue === placeholder)
    }

    setIsActive(false)

    if (onChange) {
      const selectedItem = items.find(item => item.value === currentValue)

      const currentData = isCustom ? selectedItem : currentValue

      onChange(currentData)
    }
  }

  const handleClickOutSide = () => {
    setIsActive(false)
  }

  useClickOutSide(refSelector, handleClickOutSide)

  useEffect(() => {
    if (!value && items.length > 0 && isCustom) {
      setSelectedValue(items[0])
    }
  }, [])

  return (
    items &&
    items.length > 0 && (
      <div className={wrapClass}>
        <div ref={refSelector} className={`relative ${hideLabel ? 'is-hide-label' : ''} ${contentClass}`}>
          <button
            type="button"
            className={clsx('relative select-dropdown text-left input peer', classInput, hideLabel && 'pt-[5px]', isActive && 'is-active')}
            required={required}
            disabled={disabled}
            onClick={() => setIsActive(!isActive)}
          >
            {isCustom ? selectedValue.name : selectedValue}
          </button>
          <div className={`dropdown-wrapper ${isActive ? 'is-open' : ''}`}>
            <div className="dropdown-items">
              {items.map((item) => (
                <button
                  type="button"
                  className={`item block w-full text-left ${(isCustom ? selectedValue.name : selectedValue) === item.name && 'is-active'}`}
                  data-value={item.value}
                  onClick={onChangeValue}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
          {label && (
            <span className={`input-label ${classLabel}`}>
              {label}
              {required && '*'}
            </span>
          )}
        </div>
        {error !== '' && <div className="input-error">{error}</div>}
      </div>
    )
  )
}

export default CustomDropdown
